<template>
  <div class="new-visit-container">
    <transition
      name="slide"
      mode="out-in"
    >
      <div v-if="show">
        <template v-if="!favouritePartner || !hideFavPartner">
          <search-bar
            class="new-visit-search-bar"
            v-if="$route.name.includes('PickServiceStation') || $route.name.includes('EditServiceStation')"
          />
          <div class="new-visit-wrapper">
            <add-partner
              :show-button="false"
              v-if="!favouritePartner && !noAuthRoute"
            />
            <service-station-block
              class="choose-station-view card-block"
              :class="{
                'selected': isSelected(serviceStation),
              }"
              v-for="(serviceStation, index) in serviceStations"
              v-if="serviceStation.isActive"
              :key="index"
              :set-favourite="true"
              :style="{ order: order(serviceStation) }"
              :service-station="serviceStation"
              :show-details="false"
              :show-page-link="false"
              @set_favourite="onSetFavourite(serviceStation)"
              :with-slot="true"
              :show-fav-label="isFavourite(serviceStation)"
            >
              <standard-button
                custom-class="choose-station-button fluid"
                :text="isSelected(serviceStation) ? 'Wybrano' : 'Wybierz'"
                :class-type="isSelected(serviceStation) ? 'secondary' : 'primary'"
                @buttonClick="onClick(serviceStation)"
              />
            </service-station-block>
          </div>
        </template>
        <div
          class="favourite-partner-wrapper"
          v-else
        >
          <service-station-block
            class="choose-station-view card-block favourite-partner"
            :service-station="favouritePartner"
            :show-details="true"
            :show-image="true"
            :set-favourite="true"
            :with-slot="true"
            :show-fav-label="true"
          >
            <standard-button
              custom-class="change-button fluid"
              @buttonClick="changeServicePartner()"
              text="Zmień Partnera Serwisowego"
            />
          </service-station-block>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ServiceStationBlock from '~/ServiceStationBlock';
import StandardButton from '~/StandardButton';
import SearchBar from '~/SearchBar';
import AddPartner from '~/AddPartner';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    ServiceStationBlock,
    SearchBar,
    StandardButton,
    AddPartner,
  },
  data() {
    return {
      show: false,
      hideFavPartner: true,
    };
  },
  computed: {
    ...mapGetters({
      serviceStations: 'serviceStations/getFiltered',
      buttonColor: 'brand/getThirdColor',
      primaryColor: 'brand/getPrimaryColor',
      chosenCar: 'car/getChosenCarSpecs',
      favouritePartner: 'user/getFavouritePartner',
      selectedPartner: 'visit/selectedPartner',
      closestStation: 'serviceStations/getClosest',
    }),
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
    carID() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      }
      return this.chosenCar.id;
    },
    noAuthRoute() {
      return this.$route.path.includes('no_auth');
    },
  },
  methods: {
    ...mapActions({
      setSelectedVin: 'visit/setSelectedVin',
      setSelectedLicensePlate: 'visit/setSelectedLicensePlate',
      setSelectedCarModelID: 'visit/setSelectedCarModelID',
      setSelectedVisitDate: 'visit/setSelectedVisitDate',
      setRegisteredVisit: 'visit/setRegistered',
      setSelectedPrice: 'visit/setPrice',
      setSelectedPartner: 'visit/setSelectedPartner',
      setSelectedServices: 'visit/setSelectedServices',
      loadSavedData: 'visit/loadSavedData',
    }),
    order(serviceStation) {
      if (this.isFavourite(serviceStation)) {
        return '0';
      } if (this.isClosest(serviceStation)) {
        return '1';
      }
      return '10';
    },
    isSelected(serviceStation) {
      if (this.selectedPartner) {
        return this.selectedPartner.id === serviceStation.id;
      }
      return false;
    },
    isClosest(serviceStation) {
      if (this.closestStation && serviceStation) {
        return serviceStation.id === this.closestStation.id;
      }
      return false;
    },
    onClick(serviceStation) {
      const isEditRoute = this.$route.path.includes('edit');

      this.setSelectedPartner(serviceStation);
      this.setSelectedServices(null);
      this.setSelectedVisitDate(null);

      if (isEditRoute) {
        this.setSelectedVisitDate(null);
      }
    },
    onSetFavourite(serviceStation) {
      this.hideFavPartner = true;
      this.onClick(serviceStation);
    },
    isFavourite(serviceStation) {
      if (serviceStation !== null && this.favouritePartner !== null) {
        if (serviceStation.id && this.favouritePartner.id) {
          return serviceStation.id === this.favouritePartner.id;
        }
      }
      return false;
    },
    changeServicePartner() {
      this.hideFavPartner = false;
    },
  },
  mounted() {
    const isEditRoute = this.$route.path.includes('edit');

    this.loadSavedData();

    if (!isEditRoute) {
      this.show = true;

      if (this.favouritePartner && !this.selectedPartner) {
        this.setSelectedPartner(this.favouritePartner);
      }
    } else {
      this.show = true;
    }
  },
};
</script>
